import React, { useContext } from 'react';
import _noop from 'lodash/noop';
import { useStyletron } from 'baseui';

import { ModalContext, AppContext } from 'commons-ui';

import usePagesService from 'pages/useService';
import { VIEW_FIELD_KEYS } from '../constants';
import { ACTION_IDS } from './constants';
import useService from './useService';

export const makeActionHandler = (actionId: string, params: any) => {
	const { setKeyData, tid, transactionAllDetails } = params;
	const { getRazorpayPayoutDetails } = useService();
	const { getCouponTnc } = usePagesService();

	const { setModalConfig } = useContext(ModalContext);
	const { showAlert } = useContext(AppContext);
	const [css] = useStyletron();

	switch (actionId) {
		case ACTION_IDS.GET_RAZORPAY_PAYOUT_ID:
			return async () => {
				const data = await getRazorpayPayoutDetails(tid);
				setKeyData(data[VIEW_FIELD_KEYS.RAZORPAY_PAYOUT_ID] || data[VIEW_FIELD_KEYS.RAZORPAY_PAYOUT_MSG]);
			};
		case ACTION_IDS.GET_COUPON_TNC:
			return async () => {
				try {
					const { tncHTML, couponCode, couponId } = await getCouponTnc({
						couponCode: transactionAllDetails?.extras?.couponCode,
						couponId: transactionAllDetails?.extras?.couponId
					});
					setModalConfig({
						isOpen: true,
						header: 'Terms & Conditions',
						// eslint-disable-next-line react/no-danger
						content: (
							<>
								<div
									className={css({
										padding: '20px',
										flexDirection: 'column'
									})}>
									<div
										className={css({
											display: 'flex',
											flexDirection: 'row',
											gap: '20px'
										})}>
										<div
											className={css({
												fontWeight: 'bold'
											})}>
											Coupon ID:
										</div>
										<div>{couponId || '-'}</div>
									</div>

									<div
										className={css({
											display: 'flex',
											flexDirection: 'row',
											gap: '20px'
										})}>
										<div
											className={css({
												fontWeight: 'bold'
											})}>
											Coupon Code:
										</div>
										<div>{couponCode || '-'}</div>
									</div>

									<div
										className={css({
											marginTop: '30px'
										})}>
										<div>T&C</div>
										<div
											className={css({
												padding: '20px'
											})}
											// eslint-disable-next-line react/no-danger
											dangerouslySetInnerHTML={{ __html: tncHTML }}
										/>
									</div>
								</div>
							</>
						)
					});
				} catch (error) {
					showAlert('Error in fetching coupon T&C', { type: 'error' });
				}
			};
		default:
			return _noop;
	}
};

export default {
	makeActionHandler
};
